import { render, staticRenderFns } from "./Software.vue?vue&type=template&id=fc3295aa&"
import script from "./Software.vue?vue&type=script&lang=ts&"
export * from "./Software.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports